import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const useShippingFeeStore = defineStore("shipping_fee", {
  state: () => {
    return {
      events: [],
      scope: "all",
      page: 1,
      pageCount: 0,
      perPage: 30,
      queryString: "",
      currentObj: {},
    };
  },
});

export const storeShippingFee = useShippingFeeStore(pinia);
